import React from "react";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { useTranslation } from "react-i18next";

const StatShardTooltip = (props) => {
  const { t } = useTranslation();
  const { getStatShards, getStatShardJSON } = getRiotAssetsContext();
  const { shardRow, shardId } = props;

  const shardRowJSON = getStatShards()[shardRow];
  const shardData = getStatShardJSON(shardRow, shardId);
  if (!shardData) {
    return null;
  }
  return (
    <div className="tooltip-champion-skill">
      {shardRowJSON && (
        <React.Fragment>
          <div className="name">{t ? t(shardRowJSON.key) : shardRowJSON.key}</div>
          <br />
        </React.Fragment>
      )}
      <div>{t ? t(shardData.tooltip_desc) : shardData.tooltip_desc}</div>
    </div>
  );
};

export default StatShardTooltip;
